import { render } from "./MyAds.vue?vue&type=template&id=be89eb8c"
import script from "./MyAds.vue?vue&type=script&lang=js"
export * from "./MyAds.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__